import { Link } from 'react-router-dom';
import { SITE_CONFIG, NAV_LINKS } from '../../constants';
import { FadeInUp, StaggerContainer, StaggerItem } from './Animations';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-earth-800 text-earth-200">
      <div className="container-custom py-8 sm:py-12 md:py-16">
        <StaggerContainer className="grid grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 lg:gap-12">
          {/* Brand */}
          <StaggerItem className="col-span-2">
            <Link to="/" className="inline-flex items-center gap-2 mb-3 sm:mb-6">
              <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full overflow-hidden bg-white shadow-sm">
                <img 
                  src="/logo.crop.png" 
                  alt="Beyond Class" 
                  className="w-full h-full object-cover"
                />
              </div>
              <span className="text-base sm:text-lg md:text-xl font-semibold text-sand-100">
                {SITE_CONFIG.name}
              </span>
            </Link>
            <p className="text-earth-400 mb-4 sm:mb-6 md:mb-8 max-w-md leading-relaxed text-xs sm:text-sm md:text-base">
              Ensino de inglês com a experiência de quem já viveu em mais de 40 países. 
              Aprenda com professores que conhecem o mundo e podem te preparar para qualquer desafio internacional.
            </p>

            {/* Social Links */}
            <div className="flex gap-2 sm:gap-3">
              <a
                href={`https://instagram.com/${SITE_CONFIG.instagram.replace('@', '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-earth-700 flex items-center justify-center text-earth-400 hover:bg-olive-600 hover:text-white transition-all"
              >
                <i className="ri-instagram-line text-base sm:text-lg"></i>
              </a>
              <a
                href={`https://wa.me/${SITE_CONFIG.whatsapp}?text=Olá! Vim pelo site da Beyond Class.`}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-lg bg-earth-700 flex items-center justify-center text-earth-400 hover:bg-olive-600 hover:text-white transition-all"
              >
                <i className="ri-whatsapp-line text-base sm:text-lg"></i>
              </a>
            </div>
          </StaggerItem>

          {/* Quick Links */}
          <StaggerItem>
            <h4 className="text-xs sm:text-sm md:text-base font-semibold mb-3 sm:mb-4 md:mb-6 text-sand-100">
              Navegação
            </h4>
            <ul className="space-y-1.5 sm:space-y-2 md:space-y-3">
              {NAV_LINKS.filter(link => !link.children).map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-earth-400 hover:text-sand-200 transition-colors text-xs sm:text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </StaggerItem>

          {/* Services */}
          <StaggerItem>
            <h4 className="text-xs sm:text-sm md:text-base font-semibold mb-3 sm:mb-4 md:mb-6 text-sand-100">
              Nossos Serviços
            </h4>
            <ul className="space-y-1.5 sm:space-y-2 md:space-y-3">
              {NAV_LINKS.find(link => link.label === 'Experiências')?.children?.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-earth-400 hover:text-sand-200 transition-colors text-xs sm:text-sm"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </StaggerItem>
        </StaggerContainer>

        {/* Bottom Bar */}
        <FadeInUp className="border-t border-earth-700 mt-8 sm:mt-10 md:mt-12 pt-5 sm:pt-6 md:pt-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4">
            <p className="text-earth-500 text-xs sm:text-sm">
              © {currentYear} {SITE_CONFIG.name}. Todos os direitos reservados.
            </p>
            <p className="text-earth-500 text-xs sm:text-sm">
              Recife, PE · Brasil
            </p>
          </div>
        </FadeInUp>
      </div>
    </footer>
  );
}
